import React from 'react';

const LogoSpotifyColorSvg = (props) => (
    <svg viewBox="0 0 72 72" {...props}>
        <rect
            fill="#fff"
            x={10}
            y={18}
            width={53}
            height={36}
            rx={6.73}
            ry={6.73}
        />
        <path
            fill="#1ed760"
            d="M57 32c-11.43-6.79-30.28-7.41-41.19-4.1a3.32 3.32 0 1 1-1.93-6.35c12.52-3.8 33.35-3.07 46.5 4.74A3.32 3.32 0 0 1 57 32zm-.4 10a2.77 2.77 0 0 1-3.8.91c-9.53-5.86-24.06-7.55-35.33-4.13a2.76 2.76 0 1 1-1.61-5.29c12.88-3.91 28.89-2 39.83 4.71a2.76 2.76 0 0 1 .91 3.8zm-4.34 9.65a2.21 2.21 0 0 1-3 .74C40.9 47.33 30.42 46.18 18.07 49a2.21 2.21 0 1 1-1-4.31c13.51-3.09 25.09-1.76 34.44 4a2.21 2.21 0 0 1 .73 3zM36 .54A35.46 35.46 0 1 0 71.46 36 35.46 35.46 0 0 0 36 .54z"
        />
    </svg>
);

LogoSpotifyColorSvg.displayName = 'LogoSpotifyColorSvg';
export default LogoSpotifyColorSvg;
